import * as React from 'react';
import { observer } from 'mobx-react';
import { FieldState } from 'formstate';
import ContractDropdownItem from 'components/ContractDropdownItem';
import { languageStore, benefitStore } from 'stores';
import { DropdownOptionInterface } from 'components/Forms/Dropdown';
import { currentStaffContractStore as store } from 'stores';
import { reaction, IReactionDisposer } from 'mobx';

interface Props {
    fieldState: FieldState<any>,
    editMode?: boolean
}

@observer class SelectBenefit extends React.Component<Props> {

    reactionDisposer: IReactionDisposer | any;

    componentDidMount() {
        if (store.contract && store.contract.department) {
            const locationId = store.contract!.department.locationId;
            benefitStore.getBenefits(locationId);
        }

        this.reactionDisposer = reaction(() => store.currentLocationId, (locationId) => {
            if (locationId && store.contract && 
                ((store.contract.department !== null && store.contract.department.locationId !== locationId) ||
                (store.contract && store.contract!.department === null))) {

                benefitStore.getBenefits(locationId!);
            }
        })
    }

    componentWillUnmount() {
        this.reactionDisposer();
    }

    render() {
        const { fieldState, editMode } = this.props;

        let opts: Array<DropdownOptionInterface> = [];
        benefitStore.benefits.forEach((benefit) => {
            opts.push({
                value: benefit.id,
                name: benefit.name
            })
        })

        return (
            <ContractDropdownItem
                label={languageStore.get('perk')}
                id='benefit'
                placeholderText={languageStore.get('selectPerk')}
                fieldState={fieldState}
                options={opts}
                editMode={editMode} />
        )
    }

}

export default SelectBenefit;